import { Product } from '~/lib/data-contract/salesforce';
import {
    FOUR_TO_SEVEN_DAYS_CODES,
    isExtendedDelivery,
    SEVEN_TO_ELEVEN_DAYS_CODES,
    Typography,
} from '~/shared/components';
import { useTranslation } from '~/shared/utils/translation';
import styles from './NotifyBanner.module.scss';

type Props = {
    products: Product[];
};

export const NotifyBanner = ({ products }: Props) => {
    const { translate } = useTranslation();

    const extendedDeliveryCodes: string[] = products
        .filter(isExtendedDelivery)
        .map(({ c_deliveryDays }) => c_deliveryDays);

    if (!extendedDeliveryCodes.length) return null;

    const hasDeliveryCodeIn = (group: string[]) =>
        extendedDeliveryCodes.some((code) => group.includes(code));

    // Strictest first; falls through when a text is empty.
    const notice =
        (hasDeliveryCodeIn(SEVEN_TO_ELEVEN_DAYS_CODES) && translate('basket.notifyBanner7To11')) ||
        (hasDeliveryCodeIn(FOUR_TO_SEVEN_DAYS_CODES) && translate('basket.notifyBanner4To7')) ||
        translate('basket.notifyBanner');

    if (!notice) return null;

    return (
        <Typography className={styles.notice} variant="paragraph-S" weight="medium" as="p">
            {notice}
        </Typography>
    );
};
